import { cookieOptions } from "./cookieOptions";
import type { CookieDefinition, CookieOptions } from "./cookies";

function serializeOptions(options: CookieOptions): string {
  const parts: string[] = [];
  if (options.maxAge !== undefined) parts.push(`Max-Age=${options.maxAge}`);
  if (options.path) parts.push(`Path=${options.path}`);
  if (options.sameSite) {
    parts.push(`SameSite=${options.sameSite.charAt(0).toUpperCase()}${options.sameSite.slice(1)}`);
  }
  if (options.secure) parts.push("Secure");
  if (options.httpOnly) parts.push("HttpOnly");
  return parts.join("; ");
}

export function serializeCookie(
  cookie: CookieDefinition,
  value: string,
  overrides: Partial<CookieOptions> = {},
): string {
  const options = cookieOptions(cookie, overrides);
  const suffix = serializeOptions(options);
  return `${cookie.name}=${encodeURIComponent(value)}${suffix ? `; ${suffix}` : ""}`;
}
